import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.j4a_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.k4a_1 = LinkedHashMap().fc();
      }
      l4a() {
        return this.k4a_1;
      }
      k41() {
        // Inline function 'kotlin.apply' call
        this.j4a_1.k41();
        return this;
      }
      l41() {
        // Inline function 'kotlin.apply' call
        this.j4a_1.l41();
        return this;
      }
      c41() {
        // Inline function 'kotlin.apply' call
        this.j4a_1.c41();
        return this;
      }
      d41() {
        // Inline function 'kotlin.apply' call
        this.j4a_1.d41();
        return this;
      }
      l4d(name) {
        // Inline function 'kotlin.apply' call
        this.j4a_1.l4d(name);
        return this;
      }
      r41(value) {
        // Inline function 'kotlin.apply' call
        this.j4a_1.r41(value);
        return this;
      }
      b42(value) {
        // Inline function 'kotlin.apply' call
        this.j4a_1.b42(value);
        return this;
      }
      w41(value) {
        // Inline function 'kotlin.apply' call
        this.j4a_1.w41(value);
        return this;
      }
      t41(value) {
        // Inline function 'kotlin.apply' call
        this.j4a_1.t41(value);
        return this;
      }
      z41(value) {
        // Inline function 'kotlin.apply' call
        this.j4a_1.z41(value);
        return this;
      }
      n4d(value) {
        // Inline function 'kotlin.apply' call
        this.j4a_1.n4d(value);
        return this;
      }
      g42(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.k4a_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.j4a_1.b4d();
        tmp0.b5(key, value);
        this.j4a_1.v40();
        return this;
      }
      v40() {
        // Inline function 'kotlin.apply' call
        this.j4a_1.v40();
        return this;
      }
      b4d() {
        return this.j4a_1.b4d();
      }
      m6() {
        this.j4a_1.m6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
